new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });

fixAccessibility();

function fixAccessibility() {
    const cartElement = document.querySelector('#slidecarthq');
    if (cartElement) {
        cartElement.setAttribute('role', 'region');
        cartElement.setAttribute('aria-label', 'Shopping cart');
    }

    const slideCart = document.querySelector('.slidecarthq-overlay')
    if (slideCart) {
        slideCart.removeAttribute('role');
    }

    const ariaHiddens = document.querySelectorAll('[aria-hidden="true"]');

    ariaHiddens.forEach(el => {
        const links = el.querySelectorAll('a');
        links.forEach(link => {
            link.setAttribute('tabindex', '-1');
        });
    });

    document.querySelectorAll('[aria-hidden="false"]').forEach(el => {
        el.querySelectorAll('a[tabindex="-1"]').forEach(link => {
            link.removeAttribute('tabindex');
        });
    });

    document.querySelectorAll('.slide, .slick-track').forEach(el => {
        el.removeAttribute('role');
        el.removeAttribute('aria-label');
    })
}